import React from 'react'
import './videoProgress.css'
import { getFirstFile } from '../utilities'

export default ({video, className}) => {
  let file = getFirstFile(video)
  let percent = 0;
  let status = '';
  let key = 'upload'
  if (video.waitingToUpload) {
    status = 'Upload queued.'
  } else if (video.queued) {
    key = 'processing'
    status = 'Queued for processing.'
  } else if (video.source_url && video.status == 0) {
    key = 'processing'
    status = 'Processing...'
  } else if (video.upload_percent > 0 && video.upload_percent < 100) {
    if (isNaN(video.upload_speed)) {
      status = 'Uploading...';
    } else {
      status = 'Uploading... ' + ((video.upload_speed / 1048576) * 8).toFixed(1).toString() + ' Mbps'
      percent = video.upload_percent || 0;
    }
  } else if (video.status == 0) {
    status = 'Uploading...';
    percent = video.upload_percent || 0;
  } else {
    key = 'processing'
    status = 'Processing...'
    percent = video.percent || 0;
  }
  return (
    <div className={(className || "") + " progress-overlay"}>
      <div className="progress-status">{status}</div>
      <div className="progress-bar-track">
        <div className="progress-bar-value" key={key} style={{width: percent.toString() + "%"}}>
        </div>
      </div>
    </div>
  )
}

/*{!(video.status > 0) || video.upload_percent > 0
        ? <div className={(video.upload_percent !== 100 ? 'active ': '') + 'upload-progress progress-row'}>
            <FaCloudUpload />
            {video.waitingToUpload
              ? <div className="progress-status">Upload queued</div>
              : <div className="progress-bar-track">
                  <div className="progress-bar-value" style={{width: (video.upload_percent || 0) + "%"}}>
                  </div>
                </div>
            }
            {video.upload_speed != null ? <span className="speed">{((video.upload_speed / 1048576) * 8).toFixed(1)} Mbps</span> : ""}
          </div>
        : ""
      }
      {video.status === 1 || (file && file.reencoded) 
        ? video.queued
          ? <div className="progress-status">Queued for processing</div>
          : <div className={(video.percent || video.upload_percent === 100 ? 'active ': '') + 'transcode-progress progress-row'}>
              <FaCogs />
              <div className="progress-bar-track">
                <div className="progress-bar-value" style={{width: (video.percent || 0) + "%"}}>
                </div>
              </div>
            </div>
        : ""
      }
      */